<template>
    <ToolButton :Editor="Editor" KnownIcon="H3" @ToolClick="Editor.chain().focus().toggleHeading({level:3}).run()" 
        :class="{ 'toggled': Editor.isActive('heading', { level: 3 }) }">

    </ToolButton>
</template>
<script>

    import ToolButton from '@/views/components/atoms/tiptap/Predefined/Buttons/ToolButton.vue';

    export default({
        components:{
            ToolButton
        },
        props:["Editor"]
    });
</script>